import { useEffect } from 'react';
import { Form, Input, Switch, Button } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';

export default function HousingStatusForm({ initialData, onSubmit, isLoading }: any) {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  useEffect(() => {
    if (initialData) form.setFieldsValue({ nameEn: initialData.nameEn || '', nameAr: initialData.nameAr || '', isActive: initialData.isActive ?? true });
  }, [initialData, form]);

  return (
    <Form form={form} layout="vertical" onFinish={onSubmit} initialValues={{ nameEn: '', nameAr: '', isActive: true }} style={{ maxWidth: 480 }}>
      <Form.Item label={t('housingStatuses.nameEn')} name="nameEn" rules={[{ required: true }]}><Input /></Form.Item>
      <Form.Item label={t('housingStatuses.nameAr')} name="nameAr" rules={[{ required: true }]}><Input dir="rtl" /></Form.Item>
      <Form.Item label={t('common.active')} name="isActive" valuePropName="checked"><Switch /></Form.Item>
      <Form.Item><Button type="primary" htmlType="submit" loading={isLoading}>{t('common.save')}</Button></Form.Item>
    </Form>
  );
}
